// ============================================================
// Calculator Card Slider
// ============================================================

import Swiper, { Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Scrollbar]);

function initCalculatorSliders() {
  const sliders = document.querySelectorAll('.calculator-card-swiper');

  sliders.forEach(function (sliderEl) {
    const wrapper = sliderEl.closest('.calculator-card-slider');
    const scrollbarEl = wrapper
      ? wrapper.querySelector('.calculator-card-scrollbar')
      : '.calculator-card-scrollbar';

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      autoHeight: true,      // wrapper shrinks to tallest visible slide
      observer: true,        // re-init if DOM changes
      observeParents: true,  // re-init if parent DOM changes

      scrollbar: {
        el: scrollbarEl,
        hide: false,
        draggable: true,
      },

      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    // Force a recalculation after fonts/images have settled
    // This fixes the hard-refresh single-slide bug
    setTimeout(function () {
      swiper.update();
    }, 300);
  });
}

// Use window load (not DOMContentLoaded) so all styles/fonts
// are applied before Swiper measures slide widths
window.addEventListener('load', initCalculatorSliders);